import { toast } from "react-toastify";


import SendingsService from "Services/sendings";
import MaterialsService from "Services/materials";
import I18n from "Services/i18n";
import {
  ABORT_MESSAGE,
  CommonAbortController,
} from "../Services/abortController";

export const CLEAR_LIST_MESSAGES = "CLEAR_LIST_MESSAGES";

export const CREATE_SENDING_REQUESTED = "CREATE_SENDING_REQUESTED";
export const CREATE_SENDING_OK = "CREATE_SENDING_OK";
export const CREATE_SENDING_FAIL = "CREATE_SENDING_FAIL";

export const UPDATE_SENDING_REQUESTED = "UPDATE_SENDING_REQUESTED";
export const UPDATE_SENDING_OK = "UPDATE_SENDING_OK";
export const UPDATE_SENDING_FAIL = "UPDATE_SENDING_FAIL";

export const LOAD_SENDINGS_REQUESTED = "LOAD_SENDINGS_REQUESTED";
export const LOAD_SENDINGS_OK = "LOAD_SENDINGS_OK";
export const LOAD_SENDINGS_FAIL = "LOAD_SENDINGS_FAIL";

export const CREATE_SENDING_CLICK = "CREATE_SENDING_CLICK";
export const COPY_SENDING = "COPY_SENDING";
export const VIEW_SENDING = "VIEW_SENDING";
export const EDIT_DRAFT_SENDING = "EDIT_DRAFT_SENDING";

export const START_SENDING_REQUESTED = "START_SENDING_REQUESTED";
export const START_SENDING_OK = "START_SENDING_OK";
export const START_SENDING_FAIL = "START_SENDING_FAIL";

export const PAUSE_SENDING_REQUESTED = "PAUSE_SENDING_REQUESTED";
export const PAUSE_SENDING_OK = "PAUSE_SENDING_OK";
export const PAUSE_SENDING_FAIL = "PAUSE_SENDING_FAIL";

export const FLAGS_SENDING_REQUESTED = "FLAGS_SENDING_REQUESTED";
export const FLAGS_SENDING_OK = "FLAGS_SENDING_OK";
export const FLAGS_SENDING_FAIL = "FLAGS_SENDING_FAIL";

const serviceCreateSending = (dispatch, context) => {
  return SendingsService.createSending(context)
    .then((data) => {
      dispatch({
        type: CREATE_SENDING_OK,
        data,
      });
      toast.success(I18n.getStringByKey("toast_success-message-create"));
    })
    .catch((errors) => {
      dispatch({
        type: CREATE_SENDING_FAIL,
        errors,
      });
      toast.error(I18n.getStringByKey("toast_error-message-create"));
    });
};

export function createSending(context) {
  return (dispatch) => {
    dispatch({ type: CREATE_SENDING_REQUESTED });
    serviceCreateSending(dispatch, context);
  };
}

export function createMaterialsSending(sendingContext, images) {
  return (dispatch) => {
    dispatch({ type: CREATE_SENDING_REQUESTED });
    MaterialsService.upload(images)
      .then((result) => {
        const context = sendingContext;

        context.message_template.icon = decodeURI(result.icon_url);
        context.message_template.img = decodeURI(result.image_url);

        serviceCreateSending(dispatch, context);
      })
      .catch((errors) => {
        dispatch({
          type: CREATE_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-image-upload"));
      });
  };
}

const serviceUpdateSending = (dispatch, context) => {
  return SendingsService.updateSending(context)
    .then((data) => {
      dispatch({
        type: UPDATE_SENDING_OK,
        data,
      });
      toast.success(I18n.getStringByKey("toast_success-message-edit"));
    })
    .catch((errors) => {
      dispatch({
        type: UPDATE_SENDING_FAIL,
        errors,
      });
      toast.error(I18n.getStringByKey("toast_error-message-edit"));
    });
};

export function updateSending(context) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SENDING_REQUESTED });
    serviceUpdateSending(dispatch, context);
  };
}

export function updateMaterialsSending(sendingContext, images) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SENDING_REQUESTED });
    MaterialsService.upload(images)
      .then((result) => {
        const context = sendingContext;

        context.message_template.icon = decodeURI(result.icon_url);
        context.message_template.img = decodeURI(result.image_url);

        serviceUpdateSending(dispatch, context);
      })
      .catch((errors) => {
        dispatch({
          type: UPDATE_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-image-upload"));
      });
  };
}

export function loadSendings(offset, limit, body) {
  CommonAbortController.controller.abort();
  return (dispatch) => {
    dispatch({ type: LOAD_SENDINGS_REQUESTED });

    if (body && body?.length > 0) {
      SendingsService.loadSendings(offset, limit, body)
        .then((data) => {
          dispatch({
            type: LOAD_SENDINGS_OK,
            data,
          });
        })
        .catch((errors) => {
          if (errors.message !== ABORT_MESSAGE) {
            dispatch({
              type: LOAD_SENDINGS_FAIL,
              errors,
            });
          }
        });
    } else {
      SendingsService.loadSendings(offset, limit)
        .then((data) => {
          dispatch({
            type: LOAD_SENDINGS_OK,
            data,
          });
        })
        .catch((errors) => {
          if (errors.message !== ABORT_MESSAGE) {
            dispatch({
              type: LOAD_SENDINGS_FAIL,
              errors,
            });
          }
        });
    }
  };
}

export function createSendingClick() {
  return (dispatch) => {
    dispatch({ type: CREATE_SENDING_CLICK });
  };
}

export function copySending(sending) {
  return (dispatch) => {
    dispatch({ type: COPY_SENDING, copyData: sending, isCopy: true });
  };
}

export function viewSending(sending) {
  return (dispatch) => {
    dispatch({ type: VIEW_SENDING, viewData: sending });
  };
}

export function editDraftSending(sending) {
  return (dispatch) => {
    dispatch({ type: EDIT_DRAFT_SENDING, editData: sending, isEdit: true });
  };
}

export function archiveSending(mailingId, flags) {
  return (dispatch) => {
    dispatch({ type: FLAGS_SENDING_REQUESTED });

    SendingsService.flagsSending(mailingId, flags)
      .then((data) => {
        dispatch({
          type: FLAGS_SENDING_OK,
          data,
        });
        toast.success(I18n.getStringByKey("toast_success-message-edit"));
      })
      .catch((errors) => {
        dispatch({
          type: FLAGS_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-message-edit"));
      });
  };
}

export function startSending(sending) {
  return (dispatch) => {
    dispatch({ type: START_SENDING_REQUESTED });

    SendingsService.startSending(sending.mailing.id)
      .then((resp) => {
        dispatch({
          type: START_SENDING_OK,
          mailingId: sending.mailing.id,
          mailingStatus: resp.mailing_status,
          startDate: resp.start_date,
        });

        toast.success(I18n.getStringByKey("toast_success-message-start"));
      })
      .catch((errors) => {
        dispatch({
          type: START_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-message-start"));
      });
  };
}

export function pauseSending(sending) {
  return (dispatch) => {
    dispatch({ type: PAUSE_SENDING_REQUESTED });

    SendingsService.pauseSending(sending.mailing.id)
      .then((resp) => {
        dispatch({
          type: PAUSE_SENDING_OK,
          mailingId: sending.mailing.id,
          mailingStatus: resp.mailing_status,
        });
        toast.success(I18n.getStringByKey("toast_success-message-pause"));
      })
      .catch((errors) => {
        dispatch({
          type: PAUSE_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-message-pause"));
      });
  };
}

const serviceIntegrateRss = (dispatch, context) => {
  return SendingsService.integrateRss(context)
    .then((data) => {
      dispatch({
        type: CREATE_SENDING_OK,
        data,
      });
      toast.success(I18n.getStringByKey("toast_success-message-create"));
    })
    .catch((errors) => {
      dispatch({
        type: CREATE_SENDING_FAIL,
        errors,
      });
      toast.error(I18n.getStringByKey("toast_error-message-create"));
    });
};

export function integrateRss(context) {
  return (dispatch) => {
    dispatch({ type: CREATE_SENDING_REQUESTED });
    serviceIntegrateRss(dispatch, context);
  };
}

export function integrateRssWithMaterial(context, images) {
  return (dispatch) => {
    dispatch({ type: CREATE_SENDING_REQUESTED });
    MaterialsService.upload(images)
      .then((result) => {
        context.rss_template.icon = decodeURI(result.icon_url);
        serviceIntegrateRss(dispatch, context);
      })
      .catch((errors) => {
        dispatch({
          type: CREATE_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-image-upload"));
      });
  };
}

export const updateRssMaterialsSending = (context, images) => {
  return (dispatch) => {
    dispatch({ type: CREATE_SENDING_REQUESTED });
    MaterialsService.upload(images)
      .then((result) => {
        context.rss_template.icon = decodeURI(result.icon_url);
        serviceUpdateIntegrationRss(dispatch, context);
      })
      .catch((errors) => {
        dispatch({
          type: CREATE_SENDING_FAIL,
          errors,
        });
        toast.error(I18n.getStringByKey("toast_error-image-upload"));
      });
  };
};

const serviceUpdateIntegrationRss = (dispatch, context) => {
  return SendingsService.updateIntegrationRss(context)
    .then((data) => {
      dispatch({
        type: UPDATE_SENDING_OK,
        data,
      });
      toast.success(I18n.getStringByKey("toast_success-message-edit"));
    })
    .catch((errors) => {
      dispatch({
        type: UPDATE_SENDING_FAIL,
        errors,
      });
      toast.error(I18n.getStringByKey("toast_error-message-edit"));
    });
};

export function updateIntegrationRss(context) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SENDING_REQUESTED });
    serviceUpdateIntegrationRss(dispatch, context);
  };
}
